import {
  SvgHome,
  SvgUserGroup,
  SvgBell,
  SvgRelease,
  SvgCamera,
  SvgAutomation,
  SvgUpgrade,
  SvgCase,
  SvgAnalytics,
  SvgLicense,
  SvgSiteListIcon,
  SvgAutoPilot,
  SvgContactList,
  SvgCaseCustomer,
  SvgAudioLibrary,
  SvgDealerManagement,
  SvgProfile,
  SvgCameraMap,
  SvgVirtualGuard,
  SvgDatabase,
  SvgCustomerSiteList,
  SvgShift,
  SvgTeamAIAgent,
  SvgAlertQueue,
  SvgCommand,
} from "ui/svgs";
import { USER_ROLE } from "lib/constants";
export const navLinks = {
  [USER_ROLE.Dealer]: [
    {
      name: "Customers",
      href: "/dashboard/customers",
      icon: SvgContactList,
    },
    {
      name: "Site List",
      href: "/dashboard/contact-list",
      icon: SvgSiteListIcon,
    },
    {
      name: "Alerts",
      href: "/dashboard/device-health",
      icon: SvgBell,
    },
    {
      name: "Shift",
      href: "/dashboard/schedule",
      icon: SvgShift,
      subMenu: [
        {
          name: "Schedule",
          href: "/dashboard/schedule",
        },
        {
          name: "Schedule Template",
          href: "/dashboard/template-schedule",
        },
        { name: "Group", href: "/dashboard/group" },
      ],
    },
    {
      name: "AI Queue",
      href: "/dashboard/ai-queue/monitor",
      icon: SvgCommand,
      subMenu: [
        // {
        //   name: "Command Monitor",
        //   href: "/dashboard/ai-queue/monitor",
        // },
        {
          name: "Config",
          href: "/dashboard/ai-queue/config",
        },
      ],
    },
    { name: "Organization", href: "/dashboard/dealer-org", icon: SvgUserGroup },
    {
      name: "License",
      href: "/dashboard/license",
      icon: SvgLicense,
    },
    {
      name: "Speaker Audio",
      icon: SvgAudioLibrary,
      href: "/dashboard/audio-library",
      subMenu: [
        {
          name: "Audio Library",
          href: "/dashboard/audio-library",
        },
        {
          name: "Audio Template",
          href: "/dashboard/audio-template",
        },
      ],
    },
    {
      name: "Camera Map",
      href: "/dashboard/camera/map",
      icon: SvgCameraMap,
    },
    {
      name: "Profile",
      href: "/dashboard/profile",
      icon: SvgProfile,
      subMenu: [
        {
          name: "Profile",
          href: "/dashboard/profile",
        },
        {
          name: "Open API",
          href: "/dashboard/open-api",
        },
      ],
    },
  ],
  [USER_ROLE.Distributor]: [
    {
      name: "Dealer Management",
      href: "/dashboard/distributor",
      icon: SvgDealerManagement,
    },
  ],
  [USER_ROLE.DealerRep]: [
    {
      name: "Customers",
      href: "/dashboard/customers",
      icon: SvgCaseCustomer,
    },
  ],
  [USER_ROLE.Customer]: [
    { name: "Home", href: "/dashboard/home", icon: SvgHome, menu: true },
    {
      name: "Cameras",
      href: "/dashboard/streaming",
      icon: SvgCamera,
    },
    {
      name: "Alerts",
      href: "/dashboard/alerts/basic",
      icon: SvgBell,
      menu: true,
    },
    { name: "Case", href: "/dashboard/cases", icon: SvgCase, menu: true },
    {
      name: "AutoPilot",
      href: "/dashboard/autopilot",
      icon: SvgAutoPilot,
    },
    {
      name: "Inspector",
      icon: SvgVirtualGuard,
      href: "/dashboard/virtual-guard",
      subMenu: [
        {
          name: "Inspector Configuration",
          href: "/dashboard/virtual-guard",
        },
        {
          name: "Inspector Template",
          href: "/dashboard/virtual-guard-template",
        },
        {
          name: "Inspector Progress",
          href: "/dashboard/virtual-guard-progress",
        },
      ],
    },
    {
      name: "Configuration",
      href: "/dashboard/automation",
      icon: SvgAutomation,
    },
    {
      name: "Report",
      href: "/dashboard/analytics/report",
      icon: SvgAnalytics,
    },
    {
      name: "Organization",
      href: "/dashboard/organization",
      icon: SvgUserGroup,
      subMenu: [
        {
          name: "Site",
          href: "/dashboard/customer-site-list",
        },
        {
          name: "Team",
          href: "/dashboard/organization",
        },
        {
          name: "Camera AI List",
          href: "/dashboard/camera-ai-list",
        },
      ],
    },
    {
      name: "Database",
      href: "/dashboard/database",
      icon: SvgDatabase,
    },
    {
      name: "Setting",
      href: "/dashboard/profile",
      icon: SvgProfile,
      subMenu: [
        {
          name: "Profile",
          href: "/dashboard/profile",
        },
        {
          name: "Usage",
          href: "/dashboard/usage",
        },
      ],
    },
    // {
    //   name: "Innovation",
    //   href: "/dashboard/team-ai-agent",
    //   icon: SvgTeamAIAgent,
    //   subMenu: [
    //     {
    //       name: "Team of AI Agent",
    //       href: "/dashboard/team-ai-agent",
    //     },
    //     {
    //       name: "Next Generation User Experience",
    //       href: "/dashboard/ngux",
    //     },
    //   ],
    // },
  ],
  [USER_ROLE.Admin]: [
    //{ name: "Home", href: "/dashboard", icon: SvgHome, menu: true },
    {
      name: "Software Management",
      href: "/dashboard/admin/upload",
      icon: SvgRelease,
    },
    {
      name: "Deivce Control",
      href: "/dashboard/admin/upgrade",
      icon: SvgUpgrade,
      subMenu: [
        {
          name: "NVR Upgrade",
          href: "/dashboard/admin/upgrade",
        },
        {
          name: "Camera Edge Upgrade",
          href: "/dashboard/admin/upgrade_camera-edge",
        },
      ],
    },
    {
      name: "Customers",
      href: "/dashboard/admin/user",
      icon: SvgCaseCustomer,
    },
    {
      name: "Cameras",
      href: "/dashboard/admin/camera",
      icon: SvgCamera,
    },
  ],
  [USER_ROLE.OrgAdmin]: [
    { name: "Home", href: "/dashboard/home", icon: SvgHome },
    { name: "Cameras", href: "/dashboard/streaming", icon: SvgCamera },
    { name: "Alerts", href: "/dashboard/alerts/basic", icon: SvgBell },
    { name: "Case", href: "/dashboard/cases", icon: SvgCase },
    { name: "AutoPilot", href: "/dashboard/autopilot", icon: SvgAutoPilot },
    {
      name: "Inspector",
      icon: SvgVirtualGuard,
      href: "/dashboard/virtual-guard",
      subMenu: [
        {
          name: "Inspector Configuration",
          href: "/dashboard/virtual-guard",
        },
        {
          name: "Inspector Template",
          href: "/dashboard/virtual-guard-template",
        },
        {
          name: "Inspector Progress",
          href: "/dashboard/virtual-guard-progress",
        },
      ],
    },
    {
      name: "Configuration",
      href: "/dashboard/automation",
      icon: SvgAutomation,
    },
    {
      name: "Organization",
      href: "/dashboard/organization",
      icon: SvgUserGroup,
      subMenu: [
        {
          name: "Site",
          href: "/dashboard/customer-site-list",
        },
        {
          name: "Team",
          href: "/dashboard/organization",
        },
      ],
    },
    { name: "Profile", href: "/dashboard/profile", icon: SvgProfile },
  ],
  [USER_ROLE.SiteManager]: [
    { name: "Home", href: "/dashboard/home", icon: SvgHome },
    { name: "Cameras", href: "/dashboard/streaming", icon: SvgCamera },
    { name: "Alerts", href: "/dashboard/alerts/basic", icon: SvgBell },
    { name: "Case", href: "/dashboard/cases", icon: SvgCase },
    { name: "AutoPilot", href: "/dashboard/autopilot", icon: SvgAutoPilot },
    {
      name: "Inspector",
      icon: SvgVirtualGuard,
      href: "/dashboard/virtual-guard",
      subMenu: [
        {
          name: "Inspector Configuration",
          href: "/dashboard/virtual-guard",
        },
        {
          name: "Inspector Template",
          href: "/dashboard/virtual-guard-template",
        },
        {
          name: "Inspector Progress",
          href: "/dashboard/virtual-guard-progress",
        },
      ],
    },
    {
      name: "Configuration",
      href: "/dashboard/automation",
      icon: SvgAutomation,
    },
    { name: "Profile", href: "/dashboard/profile", icon: SvgProfile },
  ],
  [USER_ROLE.ContactUser]: [],

  [USER_ROLE.Technician]: [
    { name: "Customers", href: "/dashboard/customers", icon: SvgCaseCustomer },
    {
      name: "Site List",
      href: "/dashboard/contact-list",
      icon: SvgContactList,
    },
    { name: "Alerts", href: "/dashboard/device-health", icon: SvgBell },
    {
      name: "Speaker Audio",
      icon: SvgAudioLibrary,
      href: "/dashboard/audio-library",
      subMenu: [
        {
          name: "Audio Library",
          href: "/dashboard/audio-library",
        },
        {
          name: "Audio Template",
          href: "/dashboard/audio-template",
        },
      ],
    },
    { name: "Camera Map", href: "/dashboard/camera/map", icon: SvgCameraMap },
    { name: "Profile", href: "/dashboard/profile", icon: SvgProfile },
  ],

  [USER_ROLE.Operator]: [
    {
      name: "Alerts Queue",
      href: "/dashboard/alerts/queue",
      icon: SvgAlertQueue,
    },
    { name: "Alerts History", href: "/dashboard/alerts/focus", icon: SvgBell },
    { name: "AutoPilot", href: "/dashboard/autopilot", icon: SvgAutoPilot },
  ],
  [USER_ROLE.ProjectManager]: [
    { name: "Home", href: "/dashboard/home", icon: SvgHome, menu: true },
    {
      name: "Cameras",
      href: "/dashboard/streaming",
      icon: SvgCamera,
    },
    {
      name: "Alerts",
      href: "/dashboard/alerts/basic",
      icon: SvgBell,
      menu: true,
    },
    { name: "Case", href: "/dashboard/cases", icon: SvgCase, menu: true },
    {
      name: "AutoPilot",
      href: "/dashboard/autopilot",
      icon: SvgAutoPilot,
    },
    {
      name: "Inspector",
      icon: SvgVirtualGuard,
      href: "/dashboard/virtual-guard",
      subMenu: [
        {
          name: "Inspector Configuration",
          href: "/dashboard/virtual-guard",
        },
        {
          name: "Inspector Template",
          href: "/dashboard/virtual-guard-template",
        },
        {
          name: "Inspector Progress",
          href: "/dashboard/virtual-guard-progress",
        },
      ],
    },
    {
      name: "Configuration",
      href: "/dashboard/automation",
      icon: SvgAutomation,
    },
    {
      name: "Report",
      href: "/dashboard/analytics/report",
      icon: SvgAnalytics,
    },
    {
      name: "Organization",
      href: "/dashboard/organization",
      icon: SvgUserGroup,
      subMenu: [
        {
          name: "Site",
          href: "/dashboard/customer-site-list",
        },
        {
          name: "Team",
          href: "/dashboard/organization",
        },
      ],
    },
  ],
  [USER_ROLE.Dispatcher]: [
    { name: "Case", href: "/dashboard/cases", icon: SvgCase },
    { name: "AutoPilot", href: "/dashboard/autopilot", icon: SvgAutoPilot },
  ],
  [USER_ROLE.Inspector]: [
    { name: "Alerts", href: "/dashboard/alerts/focus", icon: SvgBell },
    { name: "AutoPilot", href: "/dashboard/autopilot", icon: SvgAutoPilot },
  ],
  [USER_ROLE.DealerAdmin]: [
    { name: "Customers", href: "/dashboard/customers", icon: SvgCaseCustomer },
    {
      name: "Site List",
      href: "/dashboard/contact-list",
      icon: SvgContactList,
    },
    { name: "Alerts", href: "/dashboard/device-health", icon: SvgBell },
    { name: "Organization", href: "/dashboard/dealer-org", icon: SvgUserGroup },
    { name: "License", href: "/dashboard/license/purchase", icon: SvgLicense },
    {
      name: "Speaker Audio",
      icon: SvgAudioLibrary,
      href: "/dashboard/audio-library",
      subMenu: [
        {
          name: "Audio Library",
          href: "/dashboard/audio-library",
        },
        {
          name: "Audio Template",
          href: "/dashboard/audio-template",
        },
      ],
    },
    { name: "Camera Map", href: "/dashboard/camera/map", icon: SvgCameraMap },
    {
      name: "Profile",
      href: "/dashboard/profile",
      icon: SvgProfile,
      subMenu: [
        {
          name: "Profile",
          href: "/dashboard/profile",
        },
        {
          name: "Open API",
          href: "/dashboard/open-api",
        },
      ],
    },
  ],
  [USER_ROLE.Scheduler]: [
    {
      name: "Shift",
      href: "/dashboard/schedule",
      icon: SvgShift,
      subMenu: [
        {
          name: "Schedule",
          href: "/dashboard/schedule",
        },
        {
          name: "Schedule Template",
          href: "/dashboard/template-schedule",
        },
        { name: "Group", href: "/dashboard/group" },
      ],
    },
  ],
};
